import cs from 'classnames';
import type { ReactNode } from 'react';
import { Col, Row, Text } from 'ui';

type P = {
  label: string;
  underline?: boolean;
  value?: ReactNode | string;
};

const SummaryLine = ({ label, underline: underlined = true, value }: P) => (
  <Row className={cs('summary-line', { 'summary-line--underline': underlined })}>
    <Col span={12}>
      <Text>{label}</Text>
    </Col>
    <Col className="summary-line__value" span={12}>
      <Text strong>{value}</Text>
    </Col>
  </Row>
);

export default SummaryLine;
